import { TServerErrorResponse, CustomPromptEntity } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const GET_CUSTOM_PROMPTS = "get-custom-prompts";

export const getCustomPrompts = async () => {
  try {
    const response = await http.get<CustomPromptEntity[]>(
      links.customPrompt.index,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createCustomPrompt = async (
  data: Pick<CustomPromptEntity, "name" | "prompt"> & { isDefault?: boolean },
) => {
  try {
    const response = await http.post<CustomPromptEntity>(
      links.customPrompt.index,
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateCustomPrompt = async (
  id: string,
  data: Partial<Pick<CustomPromptEntity, "name" | "prompt" | "isDefault">>,
) => {
  try {
    const response = await http.put<CustomPromptEntity>(
      links.customPrompt.customPromptById(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteCustomPrompt = async (id: string) => {
  try {
    const response = await http.delete<CustomPromptEntity>(
      links.customPrompt.customPromptById(id),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
